import { PersistentData, type PersistentDataTypes } from "@/helpers/PersistentData";
import { useEffect, useState } from "react";

export function usePersistentDataState<
  T extends keyof PersistentDataTypes,
  K extends PersistentDataTypes[T]
>(
  key: T,
  defaultValue: K,
  initialValue: K | undefined = undefined
): [K | undefined, (value: K) => Promise<void>] {
  const [value, setValue] = useState<K | undefined>(initialValue);

  useEffect(() => {
    PersistentData.get(key).then((v) => {
      setValue((v as K | undefined) ?? defaultValue);
    });

    return PersistentData.addOnChangeListener(() => {
      PersistentData.get(key).then((v) => {
        setValue((v as K | undefined) ?? defaultValue);
      });
    });
  }, [key]);

  const set = async (newValue: K) => {
    setValue(newValue);
    await PersistentData.set(key, newValue);
  };

  return [value, set];
}
